import produce from 'immer';
import { registerReducer } from '../../../StateSetup/RootReducer';

export const ACTION_NAME = 'action/resetCanadaPostAddressSuggestion';

/**
 * Reset Canada Post address suggestion list to empty array when user choose any of the address from dropdown.
 * @param {object} state
 */
export const ResetCanadaPostAddressSuggestion = () => ({
    type: ACTION_NAME,
});

/**
 * Fired off when the ResetCanadaPostAddressSuggestion is called.
 * @param {object} state
 * @param {object} action
 */
export const reducer = produce((state) => {
    state.CanadaPostAddress.suggestionDropDownAddressList = [];
});

registerReducer(ACTION_NAME, reducer);
